/**
 * Resolve a value that may carry a token reference like `"$brand"` against
 * the page theme. If the value starts with `$` and matches a token we know
 * about, return the resolved string; otherwise return it unchanged.
 *
 * Currently only color tokens are resolved (the only typed value-class on
 * the theme); fontFamily / radius are applied via CSS variables instead.
 */
export function resolveColorToken(value, theme) {
    if (!value || value[0] !== "$")
        return value;
    const name = value.slice(1);
    return theme?.colors?.[name] ?? value;
}
/**
 * Validate an anchor name for use as an HTML element `id`. The check is
 * stricter than HTML5 (which allows almost anything) so that:
 *  - the anchor works in URL fragments without escaping
 *  - it doesn't collide with builder-internal ids (data-* attributes)
 *  - it can be safely interpolated into CSS selectors
 */
export function isValidAnchor(value) {
    if (!value)
        return false;
    return /^[a-zA-Z][a-zA-Z0-9_-]*$/.test(value);
}
//# sourceMappingURL=types.js.map